<template>
  <div id="app">
    <div v-if="isMaintenanced" class="maintenance-wrap">
      <iframe
        :src="`https://info.tabling.co.kr/message/maintenance.html`"
        width="100%"
        height="100%"
        frameborder="0">
      </iframe>
    </div>
    <template v-else>
      <div v-if="!isProduction" class="language-bar-container">
        <transition name="slide-down">
          <div v-show="isLanguageBarVisible" class="language-bar-wrapper">
            <LanguageBar />
          </div>
        </transition>
        <div
          class="language-toggle-button"
          @click="toggleLanguageBar"
          :class="{ 'is-open': isLanguageBarVisible }"
        >
        </div>
      </div>
      <router-view />
    </template>
    <div v-if="getDisplayVersion.length > 0" class="version-wrap">{{ getDisplayVersion }}</div>
  </div>
</template>
<script>
import { getPushSocketInstance } from '@/shared/socket'
import { isValidLoginStatus } from '@/shared/validation/login/index'
import { mapState } from 'vuex'
import { renewalOtpNumber } from './utills'
import LanguageBar from '@/components/LanguageBar.vue'

export default {
  name: 'app',
  components: {
    LanguageBar
  },
  data () {
    return {
      isLanguageBarVisible: false
    }
  },
  computed: {
    getDisplayVersion () {
      const result = (process.env.VUE_APP_STEP !== 'pro') ? `build: ${process.env.VUE_APP_BUILD_NO || 'local'} | v${require('../package.json').version} (${process.env.VUE_APP_STEP})`
        : ''
      return result
    },
    isProduction () {
      return process.env.VUE_APP_STEP === 'pro'
    },
    ...mapState(['isMaintenanced', 'otpNumber']),
    pushSocket () {
      return this.$store.getters.getSocketInstance
    },
    storeIdx () {
      return this.$store.getters.getStoreIdx
    }
  },
  methods: {
    toggleLanguageBar () {
      this.isLanguageBarVisible = !this.isLanguageBarVisible
    }
  },
  async created () {
    document.addEventListener('resume', () => {
      console.debug('resume!!---', new Date())
      // 앱 resume 시 대기확정코드 갱신
      renewalOtpNumber()
    })
    document.addEventListener('freeze', () => {
      console.debug('freeze!!---', new Date())
    })
    // 애플리케이션 미노출 감지
    document.addEventListener('visibilitychange', () => {
      console.debug('visibilityState---', document.visibilityState, new Date())
      if (document.visibilityState === 'visible') {
        // 앱 미노출되 해제시 대기확정코드 갱신
        renewalOtpNumber()
        // 앱 미노출되 해제시 socket 연결상태 확인
        if (this.$route.name !== 'LoginView' && this.pushSocket.disconnected) {
          // socket.id가 0이면 socket instance 새로생성
          if (this.pushSocket.id === 0) {
            getPushSocketInstance()
          } else {
            // socket 재연결
            this.pushSocket.connect()
          }
        }
      }
    })
    window.addEventListener('offline', (e) => {
      console.log('offline---', e)
      this.$store.commit('setIsOffline', true)
      this.$router.push('/')
    })
    window.addEventListener('online', (e) => {
      console.log('online---', e)
      this.$store.commit('setIsOffline', false)
      window.location.reload()
    })
    if (isValidLoginStatus()) {
      // 메장정보 조회 후 store에 매장정보 저장
      await this.$store.dispatch('setRestaurant', this.storeIdx)
      renewalOtpNumber()
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/base.scss";
.maintenance-wrap {
  width: 100%;
  height: 800px;
  overflow: hidden;
  iframe {
    transform: scale(2);
  }
}
.version-wrap {
  position: absolute;
  bottom: 5px;
  left: 10px;
  z-index: 999;
}
.language-bar-container {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.language-bar-wrapper {
  margin-bottom: 0;
  animation: slideDown 0.3s ease;
}
.language-toggle-button {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #2E3137;
  border-radius: 0 0 12px 12px;
  opacity: 0.4;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  &::after {
    content: '';
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #ffffff;
    transition: transform 0.3s ease;
  }
  &.is-open {
    &::after {
      transform: rotate(180deg);
    }
  }
  &:hover {
    background: #3a3d44;
    opacity: 0.6;
  }
}
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}
.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
